import { Head, Link } from "@inertiajs/react"
import { Coffee } from "lucide-react"

import AppLayout from "@/layouts/app-layout"
import { cuppingsPath } from "@/routes"
import type { BreadcrumbItem } from "@/types"
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"

const breadcrumbs: BreadcrumbItem[] = [
  {
    title: "Sesiones de catación",
    href: cuppingsPath(),
  },
  {
    title: "Seleccionar Tipo",
    href: "/tastings/select-type",
  },
]

const productTypes = [
  {
    type: "coffee",
    title: "Café",
    description:
      "Protocolos de catación estándar SCA y CVA con ruedas de sabor interactivas, gráficos de araña e informes completos de los resultados.",
    icon: Coffee,
    bgColor: "bg-[#7C4A2F]",
    iconColor: "text-white",
  },
]

export default function SelectType() {
  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Seleccionar Tipo de Catación" />

      <div className="flex h-full flex-1 flex-col gap-8 p-6">
        {/* Product Type Cards */}
        <div className="mx-auto grid w-full max-w-5xl gap-6 md:grid-cols-2">
          {productTypes.map((product) => {
            const Icon = product.icon
            return (
              <Link
                key={product.type}
                href={`/tastings/select-format?product_type=${product.type}`}
              >
                <Card className="group hover:border-primary/50 h-full cursor-pointer transition-all hover:shadow-lg">
                  <CardHeader className="space-y-4">
                    <div className={`rounded-2xl ${product.bgColor} w-fit p-4`}>
                      <Icon className={`h-8 w-8 ${product.iconColor}`} />
                    </div>
                    <div className="space-y-2">
                      <CardTitle className="font-serif text-2xl">
                        {product.title}
                      </CardTitle>
                      <CardDescription className="text-base leading-relaxed">
                        {product.description}
                      </CardDescription>
                    </div>
                  </CardHeader>
                </Card>
              </Link>
            )
          })}
        </div>
      </div>
    </AppLayout>
  )
}
